var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_773)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.95442 0 0 8.95442 0 20C0 31.0456 8.95442 40 20 40C31.0456 40 40 31.0456 40 20C40 8.95442 31.0456 0 20 0ZM11.6837 19.9442C11.4192 19.6977 11.0694 19.5635 10.7079 19.5699C10.3464 19.5763 10.0015 19.7227 9.74582 19.9784C9.49017 20.234 9.34373 20.5789 9.33735 20.9404C9.33097 21.3019 9.46515 21.6518 9.71163 21.9163L15.293 27.4977C15.5547 27.759 15.9093 27.9058 16.2791 27.9058C16.6488 27.9058 17.0035 27.759 17.2651 27.4977L30.2884 14.4744C30.5348 14.2099 30.669 13.8601 30.6627 13.4986C30.6563 13.1371 30.5098 12.7922 30.2542 12.5365C29.9985 12.2809 29.6536 12.1344 29.2921 12.128C28.9306 12.1217 28.5808 12.2559 28.3163 12.5023L16.2791 24.5395L11.6837 19.9442Z",
    fill: "#FE6F61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.16a4b54af6d907a66f680b2f5f5e3c77.svg";
export { ForwardRef as ReactComponent };